import { createSelectField } from './createSelectField';
import type { Group } from 'modules/core/types';

const GroupField = createSelectField<Group>('auth/groups/', {
  getOptionLabel: (a: Group) => a.name,
  getOptionValue: (a: Group) => a.id.toString(),
});
export default GroupField;
